const React = require('react');
import map from 'mn-utils/map';

import {LINK_ADMIN, LINK_ADMIN_RETAILERS, LINK_ADMIN_TRANSACTIONS} from '../../../../constants/links';
import {Link, path$} from '../../../../router';
const withState = require('../../../../utils/withState');
const Ripple = require('../../../dumb/Ripple');

module.exports = withState(() => {
  const fiatNavLinks = [
    {
      name: 'Fiat to Crypto',
      icon: require('./icons/FiatToCryptoIcon'),
      link: LINK_ADMIN,
      subLinks: [
        {
          name: 'Retailers',
          link: LINK_ADMIN_RETAILERS,
        },
        {
          name: 'Transactions',
          link: LINK_ADMIN_TRANSACTIONS,
        },
      ],
    },
  ];

  function isActive(link, path, strict) {
    return strict
            ? link === path
            : path.startsWith(link);
  }

  function renderTopLink({name, link, icon: Icon, disabled}, path, onClick) {
    const active = isActive(link, path, false);
    const current = isActive(link, path, true);
    return (
      <Ripple
        component={disabled ? 'div' : Link}
        className={`layoutRow fhaS fvaC rlv h48 pl10 f18 lh tdN fw3 dn
                  ff$2 usN cF cA3A7AC:not[.current]:not[.disabled]:h
                  (fw7).active o50.disabled` + (active ? ' active' : '') + (current ? ' current' : '')}
        disabled={disabled}
        href={disabled ? null : (link || '')}
        onClick={onClick ? onClick : null}
        activeAsParent
      >
        <div className="dN dB<1.active abs st50% xY-50% sr-20 bs bcF0 bcl3e4044 b bl20 bv26"/>
        <div className="layoutRow fhaC fvaC dn500 sq34 mr9 r ov w34>1 (cF)<1.active">
          { Icon ? <Icon /> : null }
        </div>
        <div
          className="rlv st-1 ff$3"
        >{name}</div>
      </Ripple>
    );
  }

  function renderSubLink({name, link, disabled}, path, onClick) {
    const active = isActive(link, path, false);
    return (
      <Ripple
        component={disabled ? 'div' : Link}
        className={`layoutRow fhaS fvaC rlv h26 mt22 pl55 f18 lh tdN fw3 dn
                  ff$2 usN cA3A7AC cF:not[.active]:not[.disabled]:h
                  (cF).active o50.disabled` + (active ? ' active' : '')}
        disabled={disabled}
        href={disabled ? null : (link || '')}
        onClick={onClick ? onClick : null}
        activeAsParent
      >
        <div className="dN dB<1.active w4 h4 abs st50% xY-50% r50% sl25 bgF" />
        <div className="rlv st-1 ff$3">{name}</div>
      </Ripple>
    );
  }

  return (state, props) => {
    return (
      <div className="pt55 pb20 ml-10 pt25@m">
        {map(fiatNavLinks, (item, i) => (
          <React.Fragment key={i}>
            {renderTopLink(item, state.path, props.onClick)}
            {item.subLinks && (
              <div className="mt-7">
                {map(item.subLinks, (item) => (
                  renderSubLink(item, state.path, props.onClick)
                ))}
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    );
  };
}, {
  path: path$,
});
